import { useEffect } from "react";
import { copyCurrentPageUrl, isCopyPageUrlShortcut } from "@/lib/copy-page-url";

interface CopyPageUrlShortcutProps {
  enabled: boolean;
}

/**
 * Registers Cmd/Ctrl+Shift+C to copy the current page URL on desktop viewports.
 */
export function CopyPageUrlShortcut({ enabled }: CopyPageUrlShortcutProps) {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (!isCopyPageUrlShortcut(event) || event.repeat) {
        return;
      }

      if (!window.matchMedia("(min-width: 768px)").matches) {
        return;
      }

      event.preventDefault();
      void copyCurrentPageUrl();
    };

    document.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => document.removeEventListener("keydown", handleKeyDown, { capture: true });
  }, [enabled]);

  return null;
}
